// extracted by mini-css-extract-plugin
export default {"FaqAskQuestion":"ol_a bhe_qr bhe_a bhe_w","FaqAskQuestion__outdated":"ol_b bhe_vp bhe_xe"};